<template>
    <div class="Report__field Report__field--wysiwyg">
        <div>{{ field.name }}</div>
        <div v-if="submission">
            {{ submission }}
        </div>
    </div>
</template>

<script>
import ReportFieldBoilerplate from '@/reports/Fields/Common/ReportFieldBoilerplate';

export default {
    mixins: [
        ReportFieldBoilerplate,
    ]
};
</script>
